import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
import "./CustomDatePicker.scss";
import cn from "classnames";

const CustomDatePicker = ({
                              dateFormat = "dd.MM.yyyy",
                              placeholderText = "00.00.0000",
                              bgGray = false,
                              withBorder = false,
                              IconStart = null,
                              onChange,
                              ...rest
                          }) => {

    const handleRawInput = (e) => {
        if (e.type === 'change') {  // Only handle raw typing, not picker selection
            const input = e.target.value.replace(/\D/g, "");
            let formattedValue = "";

            if (input.length > 0) {
                formattedValue = input.slice(0, 2);
                if (input.length > 2) {
                    formattedValue += "." + input.slice(2, 4);
                }
                if (input.length > 4) {
                    formattedValue += "." + input.slice(4, 8);
                }
            }

            e.target.value = formattedValue;
        }
    };

    return (
        <div
            className={cn("CustomDatePicker-wrapper", {
                ["CustomDatePicker-wrapper__border"]: withBorder,
                ["CustomDatePicker-wrapper__bgGray"]: bgGray,
                ["CustomDatePicker-wrapper__withIcon"]: IconStart,
            })}
        >
            {IconStart && (
                <div
                    className={cn("CustomDatePicker-wrapper__icon", {
                        ["CustomDatePicker-wrapper__icon_selected"]: rest.selected,
                    })}
                >
                    {IconStart}
                </div>
            )}
            <DatePicker
                dateFormat={dateFormat}
                placeholderText={placeholderText}
                locale={ru}
                onChangeRaw={handleRawInput}
                onChange={onChange}
                {...rest}
            />
        </div>
    );
};

export default CustomDatePicker;